export const chatLucideIconProps = {
  strokeWidth: 2,
} as const;
